import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import BaseDialog from '../../../../components/BaseDialog/BaseDialog';
import BuildIcon from '@material-ui/icons/BuildOutlined';

import { getString } from '../../../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class NewWorkRequestDialog extends React.Component {
  render() {
    const {
      classes,
      open,
      title,
      content,
      action,
      secondaryAction,
      disableNext,
    } = this.props;

    return (
      <div className={classes.root}>
        <BaseDialog
          open={open}
          largeTitle={true}
          title={title}
          content={content}
          buttonAction={action}
          buttonLabel={getString('app', 'MAINTENANCE_NEXT_LABEL')}
          buttonDisabled={disableNext}
          secondaryButtonAction={secondaryAction}
          secondaryButtonLabel={getString('app', 'MAINTENANCE_CANCEL_LABEL')}
          icon={BuildIcon}
          contentWrap={false}
          inlineTitle={true}
        />
      </div>
    );
  }
}

NewWorkRequestDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  secondaryAction: PropTypes.func.isRequired,
  disableNext: PropTypes.bool.isRequired,
};

NewWorkRequestDialog.defaultProps = {};

export default withStyles(styles)(NewWorkRequestDialog);
